import React from 'react';

const ProductionRecipe = () => {
  return (
    <div className="production-recipe">
      <div className="page-header">
        <h2>Üretim Reçetesi</h2>
        <p>Üretim reçetelerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default ProductionRecipe; 